import {parse_nested_list,split_outside_brackets} from './list_utils.js';

export function ensure_list(obj: any): any[] {
  if (obj == null) return [];

  if (Array.isArray(obj)) {
    return obj.flatMap(item => ensure_list(item));
  }

  const s = String(obj).trim();

  if (s.startsWith("[") && s.endsWith("]")) {
    return parse_nested_list(s);
  }

  return split_outside_brackets(s).map(x => x.trim());
}

// coerce any single value into a number (0 if it can't)
export function ensure_number(x: any): number {
  const n = Number(x);
  return isNaN(n) ? 0 : n;
}

export function ensure_string(obj: any) {
  return String(obj);
}




export function ensurelist(
	obj: any
	):any[] {
		return ensure_list(obj);
	}


export function assureList(
	obj: any
	):any[] {
		return ensure_list(obj);
	}


export function assure_list(
	obj: any
	):any[] {
		return ensure_list(obj);
	}


export function ensureList(
	obj: any
	):any[] {
		return ensure_list(obj);
	}


export function assurelist(
	obj: any
	):any[] {
		return ensure_list(obj);
	}


export function ensurenumber(
	x: any
	):number {
		return ensure_number(x);
	}


export function assureNumber(
	x: any
	):number {
		return ensure_number(x);
	}


export function ensureNumber(
	x: any
	):number {
		return ensure_number(x);
	}


export function assurenumber(
	x: any
	):number {
		return ensure_number(x);
	}


export function assure_number(
	x: any
	):number {
		return ensure_number(x);
	}


export function ensurestring(
	obj: any
	) {
		return ensure_string(obj);
	}


export function ensureString(
	obj: any
	) {
		return ensure_string(obj);
	}


export function assureString(
	obj: any
	) {
		return ensure_string(obj);
	}


export function assurestring(
	obj: any
	) {
		return ensure_string(obj);
	}


export function assure_string(
	obj: any
	) {
		return ensure_string(obj);
	}


export function assurearray(
	obj: any
	):any[] {
		return ensure_list(obj);
	}


export function ensurearray(
	obj: any
	):any[] {
		return ensure_list(obj);
	}


export function ensure_array(
	obj: any
	):any[] {
		return ensure_list(obj);
	}


export function ensureArray(
	obj: any
	):any[] {
		return ensure_list(obj);
	}


export function assure_array(
	obj: any
	):any[] {
		return ensure_list(obj);
	}


export function assureArray(
	obj: any
	):any[] {
		return ensure_list(obj);
	}
